import { a as arAE } from './ar-AE-HQY8WN1w.js';
import { d as deDE } from './de-DE-C3FlQB6O.js';
import { e as enAU } from './en-AU-BG6RAFGx.js';
import { e as enCA } from './en-CA-Bx92S5U4.js';
import { e as enGB } from './en-GB-b46sjYFy.js';
import { e as enIN } from './en-IN-C6-GV0qg.js';
import { e as enSG } from './en-SG-CNYbylKY.js';
import { e as enUS } from './en-US-DcONpFWf.js';
import { e as esCO } from './es-CO-DA6enhMu.js';
import { e as esES } from './es-ES-B1oaJo1S.js';
import { e as esMX } from './es-MX-CfKXkNyk.js';
import { f as frCA } from './fr-CA-DLcc87vY.js';
import { f as frFR } from './fr-FR-DSFwtiWH.js';
import { h as hiIN } from './hi-IN-Do80IQmX.js';
import { i as itIT } from './it-IT-DlvYqEeH.js';
import { j as jaJP } from './ja-JP-BRr2_oa0.js';
import { k as koKR } from './ko-KR-C_lOMnlp.js';
import { n as nlNL } from './nl-NL-DV7t9k8a.js';
import { p as plPL } from './pl-PL-CqVI-cgs.js';
import { p as ptBR } from './pt-BR-DpgAuNS9.js';
import { s as svSE } from './sv-SE-G2yy_UbB.js';
import { t as taIN } from './ta-IN-Dkko6b7k.js';
import { t as thTH } from './th-TH-C93Q997P.js';
import { t as trTR } from './tr-TR-C49Q0e4B.js';
import { v as viVN } from './vi-VN-CQnSOkLq.js';
import { z as zhCN } from './zh-CN-C_psRSc2.js';
import { z as zhTW } from './zh-TW-5mY-4ulK.js';

/* eslint-disable quotes, quote-props, comma-dangle, max-len */
/**
 * Imports for translations
 */
const translationComps = {
  'ar-AE': arAE,
  'de-DE': deDE,
  'en-AU': enAU,
  'en-CA': enCA,
  'en-GB': enGB,
  'en-IN': enIN,
  'en-SG': enSG,
  'en-US': enUS,
  'es-CO': esCO,
  'es-ES': esES,
  'es-MX': esMX,
  'fr-CA': frCA,
  'fr-FR': frFR,
  'hi-IN': hiIN,
  'it-IT': itIT,
  'ja-JP': jaJP,
  'ko-KR': koKR,
  'nl-NL': nlNL,
  'pl-PL': plPL,
  'pt-BR': ptBR,
  'sv-SE': svSE,
  'ta-IN': taIN,
  'th-TH': thTH,
  'tr-TR': trTR,
  'vi-VN': viVN,
  'zh-CN': zhCN,
  'zh-TW': zhTW
};
function getTranslationComponent(locale) {
  return {
    component: locale && locale in translationComps ? translationComps[locale] : enUS,
    locale: locale && locale in translationComps ? locale : 'en-US'
  };
}

export { getTranslationComponent as g };
//# sourceMappingURL=static-Djd4W_1C.js.map
